import React from 'react';
import clsx from 'clsx';
import styles from './Input.module.scss';
import {
  warnOnDisallowedProps,
  normalizeVariant,
} from '../../../designSystemGuards';

const COMPONENT_NAME = 'Input';

const ALLOWED_VARIANTS = ['default', 'error'];
const DISALLOWED_PROPS = [
  'size',
  'fullWidth',
  'width',
  'margin',
  'padding',
  'hasError',
  'isInvalid',
];

/**
 * Input
 *
 * Primitive single-line text input.
 * - Semantic control only (no layout)
 * - Size inherited from context
 * - All native <input> attributes supported
 */
const Input = (props) => {
  warnOnDisallowedProps(
    COMPONENT_NAME,
    props,
    DISALLOWED_PROPS
  );

  const {
    variant: rawVariant,
    className,
    ...nativeProps
  } = props;

  const variant = normalizeVariant(
    COMPONENT_NAME,
    rawVariant,
    ALLOWED_VARIANTS,
    'default'
  );

  return (
    <span
      className={clsx(
        styles.input,
        styles[`variant-${variant}`],
        className
      )}
    >
      <input {...nativeProps} />
    </span>
  );
};

export default Input;
